(() => {
  'use strict';

  const organizeInci = (scope = document) => {
    scope.querySelectorAll('.sovah-ingredients-panel__inci:not([data-sovah-inci-organized])').forEach((paragraph) => {
      paragraph.dataset.sovahInciOrganized = 'true';

      const ingredients = String(paragraph.textContent || '')
        .split(',')
        .map((ingredient) => ingredient.trim())
        .filter(Boolean);

      if (ingredients.length < 2) return;

      const list = document.createElement('ol');
      list.className = 'sovah-ingredients-panel__inci-list';
      list.setAttribute('aria-label', 'Ingredients in official formulation order');

      ingredients.forEach((ingredient) => {
        const item = document.createElement('li');
        const name = document.createElement('span');
        name.textContent = ingredient;
        item.appendChild(name);
        list.appendChild(item);
      });

      paragraph.replaceWith(list);
    });

    scope.querySelectorAll('.sovah-ingredients-panel__label').forEach((label) => {
      const text = String(label.textContent || '').trim().toLowerCase();
      if (text === 'official inci') label.textContent = 'Full INCI · Official order';
      if (text === 'ingredient highlights') label.textContent = 'Key Ingredient Highlights';
    });
  };

  const init = () => organizeInci(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-sovah-ingredients-open], [data-sovah-ingredients-tab]')) {
      requestAnimationFrame(init);
    }
  });
})();
